$(document).ready(function () {
   // Handle the quantity change
   $(document).on('click', '.quantity_input_block #increase-qty', function () {
      let productCard = $(this).parents('.cstm-product-card');
      let quantity = parseInt($(productCard).find('input[name="quantity"]').val());
      quantity += 1;
      $(productCard).find('input[name="quantity"]').val(quantity);
      updateTotalPrice(productCard);
   });

   $(document).on('click', '.quantity_input_block #decrease-qty', function () {
      let productCard = $(this).parents('.cstm-product-card');
      let quantity = parseInt($(productCard).find('input[name="quantity"]').val());
      if (quantity > 1) {
         quantity -= 1;
      }
      $(productCard).find('input[name="quantity"]').val(quantity);
      updateTotalPrice(productCard);
   });

   $(document).on('submit', 'form[name="customAddToCart"]', function (e) {
      e.preventDefault();
      const $form = $(this);
      const formData = $form.serializeArray();
      const variantID = $form.find('input[name="id"]').val();
      const productQuantity = $form.find('input[name="quantity"]').val();

      customAddToCartProduct(variantID, formData, $form);
   });

   updateSubscription();
   $(document).on('change', '.card .card__content input.subscribe_product', function() {
      updateSubscription($(this)); 
   });
   $(document).on('change', '.card .card__content select.selling_plan_dropdown', function() {
      updateSubscriptionOptions($(this).find("option:selected")); 
   });
});

function updateSubscription(inputElement) {
   $(inputElement).closest('.card__content.content__bottom').find(".option__text").removeClass("active");
   $(inputElement).closest('.card__content.content__bottom').find(".block_product-subscribe_opt").removeClass("active");
   const checkedInputs = inputElement || $("input.subscribe_product:checked");
   checkedInputs.each(function() {
      const checkedInput = $(this);
      const cardContent = checkedInput.closest('.card__content');
      const activeParent = checkedInput.parents(".block_product-subscribe_opt");
      const activeLabel = checkedInput.parents(".block_product-subscribe_opt").find("label");
      activeParent.addClass("active");
      activeLabel.addClass("active");

      let productPrice = "";
      let sellingPlanId = "";
      if (cardContent.find(".block_product-subscribe_opt.active .block_product-subscribe_drawer").length > 0) {
         productPrice = cardContent.find('select.selling_plan_dropdown option:selected').data('discount-price') || "";
         sellingPlanId = cardContent.find('select.selling_plan_dropdown option:selected').val() || "";
      } else {
         productPrice = cardContent.find('label.active span.block_product-grid_subscribe-price').data('price') || "";
         sellingPlanId = cardContent.find('label.active span.block_product-grid_subscribe-price').data('selling-plan-id') || "";
      }

      cardContent.find('span.buy-now-price').text(productPrice);
      cardContent.find("input[name='selling_plan']").val(sellingPlanId);
   });
}

function updateSubscriptionOptions(inputElement) {
   const checkedInput = inputElement || $("card .card__content select.selling_plan_dropdown").find("option:selected");

   if (checkedInput.length) {
      const cardContent = checkedInput.closest('.card__content');
      const productPrice = checkedInput.data('discount-price') || "";
      const discountPercentage = checkedInput.data('discount-percentage') || "";
      const sellingPlanId = checkedInput.val() || "";
      cardContent.find("label.active .block_product-grid_subscribe-price").html(`${productPrice}<small> save ${discountPercentage}%</small>`)
      cardContent.find(".update-product-block-data .block_product-grid_subscribe-price").html(`${productPrice}<small> save ${discountPercentage}%</small>`)
      cardContent.find('span.buy-now-price').text(productPrice);
      cardContent.find("input[name='selling_plan']").val(sellingPlanId);
   }
}


function customAddToCartProduct(variantID, formData, $form) {
   const data = {};
   $form.find("button").attr('disabled', true);
   $form.find(".loading__spinner").removeClass('hidden');

   formData.forEach((field) => {
      data[field.name] = field.value;
   });

   let generatedFormData = {
      items: [data],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname,
   };

   fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
         'Content-Type': 'application/json',
      },
      body: JSON.stringify(generatedFormData),
   })
      .then((response) => {
         if (!response.ok) {
            throw new Error('Network response was not ok');
         }
         return response.json();
      })
      .then((data) => {
         const cartDrawer = document.querySelector('cart-drawer');
         if (cartDrawer) {
            cartDrawer.renderContents(data);
            cartDrawer.open();
         }
      })
      .catch((error) => {
         console.error('Error:', error);
      })
      .finally(() => {
         $form.find("button").attr('disabled', false);
         $form.find(".loading__spinner").addClass('hidden');
         if ($('cart-drawer').hasClass('is-empty')) $('cart-drawer').removeClass('is-empty');
      });
}


// Function to calculate and update the total quantity price
function updateTotalPrice(productCard) {
   let quantity = parseInt($(productCard).find('input[name="quantity"]').val()) || 0;;
   let productPrice = $(productCard).find('.quantity_input_block').data('product-price');
   if (!productPrice) {
      console.error('Product price not found in data attribute');
      return;
   }
   let totalQuantityPrice = (productPrice * quantity) / 100;
   $(productCard).find('.total_quantity_price').text('$' + totalQuantityPrice.toFixed(2));
}